import React from 'react';
import PropTypes from 'prop-types';
import {t} from 'lib/I18n';

export default class UnitReward extends React.Component {
  static propTypes = {
    reward: PropTypes.object.isRequired,
    retakeable: PropTypes.bool,
    initiateRetake: PropTypes.func,
    unitType: PropTypes.string,
  }

  badgeInfoClass() {
    return "th-badge-info th-badge-info--full-screen";
  }

  render() {
    const reward = this.props.reward;
    let challengeTypeLower = reward.challenge_type.toLowerCase();

    return (
      <div className="slds-text-align--center">
        <hgroup>
          <h1 className="th-celebration-modal__heading">
            {t(`reward.unit.heading`)}
          </h1>
          <h2 className="th-text th-text--large slds-m-top--xx-large th-text--bold">
            {t(`reward.unit.subheading_${challengeTypeLower}`)}
          </h2>

          <h3 className="th-unit-reward__heading th-color--success th-text th-text--tight th-text--bold slds-m-vertical--x-large">
            {t('reward.unit.points', {points: reward.points})}
          </h3>

          <p className="slds-m-top--large slds-m-bottom--large th-text--light th-text--small">
            {t('reward.unit.encourage')}
          </p>
        </hgroup>

        <div className={this.badgeInfoClass()}>
          <img className="th-badge-info__image" src={reward.badge_url} alt="" />
          <div className="th-text th-text--default slds-m-vertical--small">
            {reward.module_title}
          </div>
          <div className="th-badge-info__progress-group">
            <div className="th-text th-text--small th-text--bold slds-m-right--xx-small">
              {reward.module_progress}%
            </div>
            <tds-progress-bar progress={reward.module_progress}></tds-progress-bar>
          </div>
        </div>
        {this.props.retakeable &&
          <div className="th-text th-text--default slds-m-top_small">
            <a onClick={this.props.initiateRetake} role="button" tabIndex="0">
              {t(`challenge.assessment.retake_${this.props.unitType}`)}
            </a>
          </div>
        }
      </div>
    );
  }
}
